import ServerResponse from "./ServerResponse";
import Survey from "./Survey";

export default class SurveyServerResposne extends ServerResponse {
    constructor() {
        super();
        this.data = new Survey()
    }
}
